import { createAction } from 'redux-actions';

const SET_REDIRECT_DETAILS = 'SET_REDIRECT_DETAILS';

export default function redirect(state = null, { payload, type }) {
  switch (type) {
    case 'SET_REDIRECT_DETAILS':
      return payload;

    default:
      return state;
  }
}

export const setRedirectDetails = (details) => {
  return (dispatch) => {
    const action = createAction(SET_REDIRECT_DETAILS)(details);
    dispatch(action);
  };
};
